// Feature flag keys, defined server-side in ReferenceData/feature-flags.json. Deliberately not part
// of the Permission union: a flag passed to hasPermission() resolves false and reads as a denial.
export enum FeatureFlag {
  AddressVerification = 'addresses.verification',
  BankReconciliation = 'finances.bankrec',
  // Off by default in feature-flags.json, and the API refuses every import route without it.
  MemberPropertyImport = 'imports.member_property',
  // Global kill switch. Read with FeatureFlagUtilities.isSwitchOn, never isEnabled.
  Maintenance = 'system.maintenance'
}

export enum FeatureFlagLoadState {
  Pending = 'pending',
  Loaded = 'loaded',
  Failed = 'failed'
}

// Tabs on the feature flag management page: flag definitions and their defaults, or the
// per-organization overrides of those defaults.
export enum FeatureFlagManagementTab {
  Flags = 'flags',
  Overrides = 'overrides'
}

// Which route the override form modal saves through: a new override, or the value of an existing one.
export enum FeatureFlagOverrideFormMode {
  Create = 'create',
  Edit = 'edit'
}
